import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';

// Components
import Layout from './components/Layout';

// Pages
import HomePage from './pages/HomePage';
import ExpertsPage from './pages/ExpertsPage';
import ExpertDetailPage from './pages/ExpertDetailPage';
import SentimentPage from './pages/SentimentPage';
import SourcesPage from './pages/SourcesPage';
import NewsPage from './pages/NewsPage';
import ArticlePage from './pages/ArticlePage';
import BotPerformancePage from './pages/BotPerformancePage'; // Import the new page

// Define a basic theme (can be customized later)
const theme = createTheme({
  cssVariables: true, // Enable CSS variables directly in the theme
  palette: {
    primary: {
      main: '#d4af37', // Gold
    },
    secondary: {
      main: '#2c3e50', // Dark blue-gray
    },
    background: {
      default: '#f8f9fa', // Light background
    },
  },
  typography: {
    fontFamily: 'Roboto, Segoe UI, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif',
  },
});

// React Router v7 future flags configuration
const routerOptions = {
  future: {
    v7_startTransition: true,
    v7_relativeSplatPath: true
  }
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline /> {/* Normalize styles */}
      <Router {...routerOptions}>
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/experts" element={<ExpertsPage />} />
            <Route path="/experts/:expertId" element={<ExpertDetailPage />} />
            <Route path="/sentiment" element={<SentimentPage />} />
            <Route path="/sources" element={<SourcesPage />} />
            <Route path="/news" element={<NewsPage />} />
            <Route path="/news/article/:id" element={<ArticlePage />} />
            <Route path="/bot-performance" element={<BotPerformancePage />} /> {/* Add route for bot performance */}
          </Routes>
        </Layout>
      </Router>
    </ThemeProvider>
  );
}

export default App;
